import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import GameType, { INIT_GAME } from "../../models/game";
import PlayerType from "../../models/player";

export interface GameState {
  game: GameType;
  winner: PlayerType | null;
  isOver: boolean;
  challengeCard: boolean;
  pickACard: boolean;
}

const initialState: GameState = {
  game: INIT_GAME,
  winner: null,
  isOver: false,
  challengeCard: false,
  pickACard: false,
};

export const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    updateGame: (state, action: PayloadAction<GameType>) => {
      state.game = action.payload;
    },
    setWinner: (state, action: PayloadAction<PlayerType | null>) => {
      state.winner = action.payload;
    },
    gameOver: (state) => {
      state.isOver = true;
    },
    cardChallengeAccepted: (state) => {
      state.challengeCard = true;
    },
    cardChallengeRejected: (state) => {
      state.challengeCard = false;
    },
    pickACard: (state) => {
      state.pickACard = true;
    },
    cardPicked: (state) => {
      state.pickACard = false;
    },
    resetGame: (state) => {
      state.isOver = false;
      state.winner = null;
      state.pickACard = false;
      state.challengeCard = false;
    },
  },
});

export const {
  updateGame,
  setWinner,
  gameOver,
  cardChallengeAccepted,
  cardChallengeRejected,
  pickACard,
  cardPicked,
  resetGame,
} = gameSlice.actions;

export default gameSlice.reducer;
